var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.514 8.223c-2.524.07-4.687 2.06-4.687 4.65 0 2.67 2.231 4.738 4.826 4.738a4.82 4.82 0 0 0 1.117-.132c.219-.074.441-.145.668-.21.505-.2.972-.483 1.38-.833-2.171-1.122-3.696-3.35-3.696-5.986 0-.788.139-1.536.392-2.227zM7.013 19.45C2.63 20.334 0 23.336 0 25.61 0 26.53.641 27 2.441 27h1.547c-.369-.476-.52-1.048-.52-1.629 0-2.082 1.383-4.279 3.517-5.9a4.08 4.08 0 0 1 .028-.022z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.032 27h1.527c1.8 0 2.441-.47 2.441-1.39 0-2.269-2.62-5.262-6.986-6.155l.02.015c2.136 1.622 3.52 3.82 3.52 5.902 0 .58-.152 1.152-.522 1.628zM21.284 17.492c.344.078.7.119 1.063.119 2.595 0 4.827-2.068 4.827-4.738 0-2.569-2.127-4.545-4.623-4.648.245.68.379 1.419.379 2.2 0 2.664-1.546 4.905-3.733 6.024.394.334.84.606 1.323.803.26.074.514.154.764.24z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.577 27h16.854c2.121 0 2.873-.551 2.873-1.629 0-3.158-4.337-7.517-11.298-7.517-6.952 0-11.289 4.359-11.289 7.518 0 1.077.752 1.628 2.86 1.628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.026 16c3.022 0 5.654-2.422 5.654-5.576C21.68 7.308 19.048 5 16.026 5 13 5 10.372 7.359 10.372 10.45c0 3.128 2.614 5.55 5.654 5.55z",
    opacity: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/User_Group.fe002b8417d65b9a5744eb39bc2bc992.svg";
export { ForwardRef as ReactComponent };